export const adaptCliente = (clienteData) => {
    return {
        cod: clienteData?.cod_Cliente,
        nombre: clienteData?.nom_com,
        cuit:  clienteData?.cUIT,
        domicilio:  clienteData?.domicilio,
        cp:  clienteData?.cP,
    }
}

export const adaptClientesArray = (
    clientesData
) => {
    return structuredClone(clientesData?.allPlanesClientes?.items)
        ?.map(planes => adaptCliente(planes));
}